var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.667 25.333h-6v-16h4.667c.37 0 .667-.298.667-.666V4h13.333v8.667a.667.667 0 001.333 0V3.333a.665.665 0 00-.666-.666H11.334a.642.642 0 00-.256.052.66.66 0 00-.216.144L5.53 8.195a.654.654 0 00-.196.472V26c0 .368.299.667.667.667h6.666a.667.667 0 000-1.334zM7.61 8l3.057-3.057V8H7.61zm22.864 16.196a.666.666 0 00-.943-.003l-5.53 5.496V16.667a.667.667 0 00-1.334 0v13.105l-5.613-5.579a.666.666 0 10-.94.946l6.708 6.666a.667.667 0 00.941 0l6.708-6.666a.668.668 0 00.003-.943zm-19.747-8.912l-.59 2.05H9.029l-1.019-6.66 1.327-.007.599 2.758.809-2.617.857 2.583.434-2.716 1.298-.008-.94 6.666h-1.07l-.597-2.049zm9.94-4.617h-5.333a.666.666 0 100 1.333h5.333a.666.666 0 100-1.333zm-5.333 2.666h5.333a.666.666 0 110 1.334h-5.333a.667.667 0 010-1.334zM20.667 16h-5.333a.667.667 0 000 1.333h5.333a.667.667 0 000-1.333zm0 4h-12a.666.666 0 110-1.333h12a.666.666 0 110 1.333z",
    fill: "#848999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.83cd2b797b2e15ff7dae7db2730625db.svg";
export { ForwardRef as ReactComponent };